export const LOAD_REASON_CODES = 'load_reason_codes';
export const REASON_CODES_LOADED = 'set_loaded_reason_codes';
export const RESET_REASON_CODES = 'reset_reason_codes';
export const SYNC_FAILED = 'reason_codes_sync_has_failed';
